import { FormatAmountProps } from './utils.types';

export const buildString = (rawString, replacements) => {
  // In Node 16+ a d flag can be provided to have the start and end indices of each matching group
  // Match avery group inside double brackets {{ }}
  const VARIABLE_MATCHER = /\{\{([^}]+)\}\}/g;

  // For es2020, worth upgrading? (current es2019)
  // let capturingGroups = [...string.matchAll(VARIABLE_MATCHER)];

  let currentMatch;
  let resultString = rawString;

  // eslint-disable-next-line no-cond-assign
  while ((currentMatch = VARIABLE_MATCHER.exec(resultString)) !== null) {
    resultString =
      resultString.substring(0, currentMatch.index) +
      replacements[currentMatch[1].trim()] +
      resultString.substring(currentMatch.index + currentMatch[0].length);
    // Return the pointer to the start of the string
    VARIABLE_MATCHER.lastIndex = 0;
  }

  return resultString;
};

export const formatAmount = ({
  children: amount,
  locale,
  currency,
  currencyDisplay,
  maximumSignificantDigits,
  round,
  noDecimal,
}: FormatAmountProps) => {
  try {
    let val: number = parseFloat(amount as string);

    if (Number.isNaN(val)) {
      console.error('Failed to parse string into number');
      return amount;
    }

    if (round) {
      val = Math.round(+amount);
    }

    let options;
    if (currency) {
      options = {
        style: 'currency',
        currencyDisplay,
        currency,
      };
    } else {
      options = { maximumSignificantDigits };
    }

    if (noDecimal) {
      options = {
        ...options,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      };
    }

    return val.toLocaleString(locale, options);
  } catch {
    return amount;
  }
};

const textFormatting = {
  buildString,
  formatAmount,
};

export default textFormatting;
